import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList() {
    // Use toast
    const toast = useToast();
    
    const refUserListTable = ref(null);
    
    // Table Handlers
    let tableColumns = [
        { key: 'access.fullName', sortable: true, label: 'Usuario' },
        { key: 'documentNumber', sortable: true, label: 'Número de documento' },
        { key: 'access.email', sortable: true, label: 'Correo' },
        { key: 'access.phone', sortable: true, label: 'Teléfono' },
        { key: 'customer.name', sortable: true, label: 'Cliente' },
        { key: 'n_courses', sortable: true, label: 'Cursos inscritos' },
        { key: 'position', sortable: true, label: 'Cargo' }
    ];
    
    if (JSON.parse(localStorage.getItem('userData')).role == 'admin'){
        tableColumns.push({ key: 'actions', label: 'Opciones' });
    }
    
    const perPage = ref(10);
    const totalUsers = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(false);
    
    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalUsers.value,
        }
    });
    
    const refetchData = () => {
        refUserListTable.value.refresh()
    };
    
    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    });
    
    const fetchUsers = (ctx, callback) => {
        store
        .dispatch('app-user/fetchUsers', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            role: JSON.parse(localStorage.getItem('userData')).role,
            customer: JSON.parse(localStorage.getItem('userData')).customer,
        })
        .then(response => {
            const { users, total } = response.data;
            callback(users);
            totalUsers.value = total;
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error al obtener la lista de usuarios',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            });
        })
    };
    
    return {
        fetchUsers,
        tableColumns,
        perPage,
        currentPage,
        totalUsers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        
        refetchData,
    }
}
